import Check from "@/components/Atoms/Check";
import InputLabel from "@/components/Atoms/InputLabel";
import {RootState} from "@/reducers/store";
import {useAddNewField,useValidate} from "@/state/survey/formSlice";
import {BasicAnswerSave} from "@/state/survey/saveAnswerSlice";
import {Utility} from "@/utils";
import _ from 'lodash';
import React,{useEffect,useRef,useState} from "react";
import {useSelector} from "react-redux";
import ValidationManager from "../../SurveyModel/fieldValidations";
import {IAnswers} from "../../SurveyModel/types/commonTypes";
import {INode,nodeConfigurations} from "../../SurveyModel/types/nodeTypes";
import Textarea from "../Textarea/Textarea";


type Option = {
  label: string;
  value: string;
};

type MultiSelectCheckboxGroupProps = {
  options: string[];
  onChange: (selected: (string)[]) => void;
  name: string
  node: INode
};

const BloodThinningMedicines: React.FC<MultiSelectCheckboxGroupProps> = (props:MultiSelectCheckboxGroupProps ) => {
    const {node   } = props;
    const [selectedValues, setSelectedValues] = useState<(string)[]>([]);
    const form = useSelector((state:RootState) => state.form);
    const validateInputField = useValidate();
    const [inputValue, setInputValue ] = useState(form[node.name].value);
    const [updatesOptions, setUpdatedOptions] = useState<Option[]>([]);
    const addNewFieldValue = useAddNewField();
    const isInitialRun = useRef(true); 
    const isInitialRunConfig = useRef(true); 
    const [otherNode, setOtherNode] = useState<INode>({
        title: 'Please tell us which other blood thinning medicines you take',
        disabled: false,
        validations: [],
        configurations:[],
        alerts: [],
        validationDependants: [],
        type: 'Textarea',
        name: 'otherMedicines',
       // showIf: '{RepeatedBloodThinningMedicine}==\u0022Other\u0022',
        nodes: [],
     });
    const otherMedicinesField = 'otherMedicines';
    const noneOptionField= 'I don\u2019t take blood thinning medicines';
    const otherField = 'Other'

    const getNodeField = (name: string, type: string )=> {
        const fieldNode = {
            name: name,
            type: type,
        }
        return fieldNode
    }

  useEffect(()=>{
    if(node.options && !updatesOptions.length  && node && node.configurations && isInitialRunConfig.current){
        const localOptopns : Option[] = []
        isInitialRunConfig.current = false
            const other = node.configurations.find((Item)=> Item.key === 'IsOtherOptionEnabled');
            //const otherNode = node.configurations.find((Item)=> Item.key === 'IsNoneOptionEnabled');
            
            node.options?.forEach((item)=>{
                const option: Option = {
                    label: item as string,
                    value: item as string
                }
                localOptopns.push(option);
               })

            if(other && other.value  ){
                const label: nodeConfigurations | undefined = node.configurations.find((Item)=> Item.key === 'OtherOptionLabel');
                const option: Option = {
                    label: 'Other',
                    value: otherField
                }
                localOptopns.splice(localOptopns.length - 1, 0, option);
                if(label) {
                    setOtherNode((prevNode) => ({
                        ...prevNode,
                        title: label.value
                    }));
                    if(!form[otherMedicinesField]){
                        const detailsNode = getNodeField(otherMedicinesField as string, 'textarea')
                        const detailsNodeForm = ValidationManager.applyCommonValidationsWithValue(detailsNode, '')
                        addNewFieldValue(otherMedicinesField, detailsNodeForm);
                    }
                   
                }
            } 
            
            setUpdatedOptions( [...updatesOptions, ...localOptopns])
    }
  },[updatesOptions, node])

    useEffect(()=>{
        if(form[node.name].value !== inputValue){
            setInputValue(form[node.name].value )
        }
    }, [form, inputValue]);


useEffect(()=>{
    if(isInitialRun.current && node ){
        const selectedValuesInitial: string[] = []
        isInitialRun.current = false
        if(typeof form[node.name]?.value === 'string'){
                let nodeValue = form[node.name]?.value 
            ? JSON.parse(form[node.name].value as string) // Safely cast to string
            : [];
            const nodeStringValues: string[] = []
            if(nodeValue.length) {
                nodeValue.forEach((element:IAnswers[]) => {
                    nodeStringValues.push(element[0].value)
                });
            }
            let textValue: string = ''
            if(nodeValue.length && node.options ) {

                textValue = _.difference(nodeStringValues, node.options as string[])[0] as string;
                nodeValue = _.intersection(nodeStringValues, node.options as string[])
            }
            if(textValue){
                validateInputField(otherMedicinesField, textValue, true);
                nodeStringValues.push('Other')
            }
        
        
            if(Array.isArray(nodeStringValues) && nodeStringValues.length > 0){
                nodeStringValues.map((checkItem: string) =>{

                    selectedValuesInitial.push(checkItem)
                });
                setSelectedValues(selectedValuesInitial);
            }else {
                setSelectedValues(selectedValuesInitial);
            }
          
        }
    }
  
}, [node, isInitialRun, form]);


const handleChange = (value: string[]) => {
    if(node.validationDependants) {
        node.validationDependants.forEach((element : string)=> {
            validateInputField(element, form[element].value, true);
        });
    }
    let formValue: string[] = []
    if(node && node.configurations &&  node.configurations.find((Item)=> Item.key === 'IsNoneOptionEnabled') &&  value.includes(noneOptionField)){
        formValue = []
        formValue.push(noneOptionField as string)
    }else if(value.includes(otherField)){
       const  nodeValues = _.intersection(value, node.options as string[])
    if(form[otherMedicinesField].value) {
            formValue = [...nodeValues, form[otherMedicinesField].value as string]
        }      
    }
    else {
        formValue = [...value]
    }
    const BloodThinningMedicinesList: BasicAnswerSave[][] = []

    formValue.forEach((item)=>{
        const answerRow: BasicAnswerSave[] = []
        const listItem = {
            name: 'RepeatedBloodThinningMedicine',
            value: item
        }
        answerRow.push(listItem);
        BloodThinningMedicinesList.push(answerRow);
    })
    validateInputField(node.name, JSON.stringify(BloodThinningMedicinesList), true);
}


const handleChangeOtherText = () => {
    handleChange(selectedValues)
}

const handleCheckboxChange = (value: string) => {
    let newSelectedValues = selectedValues.includes(value)
    ? selectedValues.filter((v) => v !== value)
    : [...selectedValues, value];
    if(node && node.configurations &&  node.configurations.find((Item)=> Item.key === 'IsNoneOptionEnabled') &&  value.includes(noneOptionField)) {
        if(selectedValues.includes(value)) {
            newSelectedValues = [ ] 
        }else {
            newSelectedValues = [ value] ;
        }
    }else {
        newSelectedValues = newSelectedValues.filter((item)=>item !==noneOptionField )
    }

    setSelectedValues(newSelectedValues)
   handleChange(newSelectedValues);
  };

  return (
    <div className={ `blood-thinning-wrap ${Utility.getClassForWidthPx(node)}  ${Utility.getClassForWidth(node)} user-input multi-select-checkbox-group`} >
         <InputLabel label={node.title} labelClasses="input-label"></InputLabel> 
        {node.subTitle  ? <InputLabel type="subTitle" label={node.subTitle } labelClasses="input-label"></InputLabel> : ''}
            {/* <SingleChoice propClasses={'single-chocie-choices flex'} value={form[node.name].value} options={node.options} name={node.name} onChange={handleChange}/> */}
        <ul>
        {updatesOptions.map((option, index) => (
        <li key={index}>

               <Check name={`checkbox${index}`} onChange={handleCheckboxChange} value={option.value} label={option.label} selectedValue={selectedValues.includes(option.value)} />
                {option.value === 'Other' && selectedValues.includes('Other') && node && node.options && form  ? <div><Textarea  node={otherNode} name={'otherMedicines'} onBlur={handleChangeOtherText} propClasses={`display-within-checkbox`}/></div>  : ''}
           
        </li>          
      ))} 
        </ul>
  
    </div>
  );
};

export default BloodThinningMedicines;
